import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonHero = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="nv-hero" id="top" aria-label="Hero">
      <div className="nv-hero__media" role="img" aria-label="Recording studio atmosphere" />

      <svg className="nv-hero__wave" viewBox="0 0 320 80" aria-hidden="true">
        {[18, 42, 28, 62, 36, 54, 24, 48, 32, 58, 22, 44].map((h, i) => (
          <rect
            key={i}
            x={i * 26 + 4}
            y={80 - h}
            width="10"
            height={h}
            rx="2"
            fill="#3ecfbf"
            opacity={0.7}
          />
        ))}
      </svg>

      <div className="nv-container nv-hero__content">
        <motion.h1
          className="nv-hero__brand"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          Neon <em>Verse</em> Studio
        </motion.h1>

        <motion.h2
          className="nv-hero__headline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          {NEONVERSE.hero.headline}
        </motion.h2>

        <motion.p
          className="nv-hero__sub"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.28 }}
        >
          {NEONVERSE.hero.subheading}
        </motion.p>

        <motion.div
          className="nv-hero__actions"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.4 }}
        >
          <button
            type="button"
            className="nv-btn nv-btn--primary"
            onClick={() => scrollTo('contact')}
          >
            {NEONVERSE.hero.primaryCta}
          </button>
          <button
            type="button"
            className="nv-btn nv-btn--ghost"
            onClick={() => scrollTo('contact')}
          >
            {NEONVERSE.hero.secondaryCta}
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default NeonHero;
